import { render, staticRenderFns } from "./DraftPriceRouteManual.vue?vue&type=template&id=a7f9443e&"
import script from "./DraftPriceRouteManual.vue?vue&type=script&lang=js&"
export * from "./DraftPriceRouteManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports